import React, { useEffect, useState } from "react";
import { getAllReviews } from "../../api/fetch";

function Provider() {
  const [allReview, setAllReviews] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    fetchAllReviews();
  }, []);

  const fetchAllReviews = async () => {
    setLoading(true);
    try {
      const res = await getAllReviews();
      console.log("RESS Reviewss ::", res);

      if (res?.status) {
        setAllReviews(res?.data);
      }
    } catch (error) {
      console.log("Error ::", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    allReview,
    isLoading,
  };
}

export default Provider;
